module.exports = __webpack_public_path__ + "img/big.c796a076.jpg";